<template>
  <div class="interstice-container"></div>
</template>

<style lang="scss" scoped>
.interstice-container {
  width: 100%;
  height: 100%;
  background-image: url('./../../assets/screen/interstice3.png');
  background-size: cover;
  background-position: 50% 50%;
  background-color: #0e0b1c;
}
</style>
